import { FilterableInterface } from './filterable.interface';

export class Part implements FilterableInterface {

  constructor(
    public hash?: string,
    public name?: string,
    public slug?: string,
    public erpTask?: string,
    public erpTaskName?: string
  ) { }

  get filterableData() {
    return this.name.toLowerCase();
  }

  clone() {
    return new Part (
      this.hash,
      this.name,
      this.slug,
      this.erpTask,
      this.erpTaskName
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/part.ts